document.addEventListener('DOMContentLoaded', () => {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

  const header = document.getElementById('header');
  if (header) {
    const updateHeader = () => header.classList.toggle('stuck', window.scrollY > 10);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const productSection = document.getElementById('product');
  const stickyBar = document.getElementById('sticky-bar');
  if (productSection && stickyBar) {
    const stickyObserver = new IntersectionObserver((entries) => {
      stickyBar.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    stickyObserver.observe(productSection);
  }

  const mainImage = document.getElementById('main-img');
  document.querySelectorAll('#gallery-thumbs .thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage) return;
      mainImage.src = thumb.dataset.src;
      document.querySelectorAll('#gallery-thumbs .thumb').forEach((item) => item.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    let quantity = 1;
    const quantityDisplay = productForm.querySelector('[data-qty-display]');
    const quantityInput = productForm.querySelector('[data-quantity-input]');
    const variantIdInput = productForm.querySelector('[data-variant-id]');
    const selectedLabels = productForm.querySelectorAll('[data-selected-option-label]');
    const addToCartButton = productForm.querySelector('#atc-btn');
    const buyNowButton = productForm.querySelector('[data-buy-now]');
    const priceEl = document.querySelector('[data-price]');
    const comparePriceEl = document.querySelector('[data-compare-price]');
    const variantDataEl = document.querySelector('[data-product-variants]');
    const variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];

    const setQuantity = (nextValue) => {
      quantity = Math.max(1, Math.min(10, nextValue));
      if (quantityDisplay) quantityDisplay.textContent = String(quantity);
      if (quantityInput) quantityInput.value = String(quantity);
    };

    const selectedOptions = () => Array.from(productForm.querySelectorAll('[data-option-position]:checked'))
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((input) => input.value);

    const syncVariant = () => {
      const options = selectedOptions();
      if (!variants.length || !options.length) return;

      selectedLabels.forEach((label) => {
        const index = Number(label.dataset.selectedOptionLabel) - 1;
        label.textContent = options[index] || label.textContent;
      });

      const variant = variants.find((item) => JSON.stringify(item.options) === JSON.stringify(options));
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = String(variant.id);

      if (priceEl && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        priceEl.textContent = window.Shopify.formatMoney(variant.price);
      }

      if (comparePriceEl && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.hidden = false;
          comparePriceEl.textContent = window.Shopify.formatMoney(variant.compare_at_price);
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (addToCartButton) addToCartButton.disabled = !variant.available;
    };

    productForm.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQuantity(quantity - 1));
    productForm.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQuantity(quantity + 1));

    productForm.querySelectorAll('[data-option-position]').forEach((input) => {
      input.addEventListener('change', syncVariant);
    });

    buyNowButton?.addEventListener('click', async () => {
      setQuantity(quantity);
      const formData = new FormData(productForm);
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      window.location.href = '/checkout';
    });

    setQuantity(1);
    syncVariant();
  }

  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const storageKey = 'pb_deadline';
    const dayMs = 86400000;
    let deadline = Number(localStorage.getItem(storageKey));

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + dayMs;
      localStorage.setItem(storageKey, String(deadline));
    }

    const tick = () => {
      if (deadline <= Date.now()) {
        deadline = Date.now() + dayMs;
        localStorage.setItem(storageKey, String(deadline));
      }

      const remaining = deadline - Date.now();
      const hours = String(Math.floor(remaining / 3600000)).padStart(2, '0');
      const minutes = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
      const seconds = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
      countdown.textContent = `${hours}h ${minutes}m ${seconds}s`;
    };

    tick();
    window.setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-faq-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      const alreadyOpen = item?.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach((openItem) => openItem.classList.remove('open'));
      if (item && !alreadyOpen) item.classList.add('open');
    });
  });

  const trackOrder = document.querySelector('[data-track-order]');
  if (trackOrder) {
    const form = trackOrder.querySelector('[data-track-form]');
    const status = trackOrder.querySelector('#track-status');
    const detail = trackOrder.querySelector('#track-detail');
    const result = trackOrder.querySelector('#track-result');
    const input = trackOrder.querySelector('#order-input');

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const order = input.value.trim().toUpperCase();
      const found = order.startsWith('PB-') && order.length >= 7;
      const message = found ? trackOrder.dataset.foundTemplate : trackOrder.dataset.notFoundTemplate;
      status.textContent = found ? trackOrder.dataset.foundStatus : trackOrder.dataset.notFoundStatus;
      detail.textContent = message.replace('{order}', order);
      result.classList.add('show');
    });
  }

  const popup = document.querySelector('[data-purchase-popup]');
  if (popup) {
    const buyers = Array.from(popup.querySelectorAll('[data-popup-buyer]')).map((el) => ({
      name: el.dataset.name,
      city: el.dataset.city,
      variant: el.dataset.variant,
      ago: el.dataset.ago
    }));
    const baseName = popup.querySelector('#pp-name')?.textContent || '';
    const nameEl = popup.querySelector('#pp-name');
    const metaEl = popup.querySelector('#pp-meta');
    let popupIndex = 0;
    let popupTimer;

    const hidePopup = () => {
      window.clearTimeout(popupTimer);
      popup.classList.remove('show');
      popupTimer = window.setTimeout(showPopup, 22000);
    };

    const showPopup = () => {
      if (!buyers.length) return;
      const buyer = buyers[popupIndex % buyers.length];
      popupIndex += 1;
      if (nameEl) nameEl.textContent = buyer.variant ? `${baseName} - ${buyer.variant}` : baseName;
      if (metaEl) metaEl.textContent = `${buyer.name} · ${buyer.city} · ${buyer.ago}`;
      popup.classList.add('show');
      popupTimer = window.setTimeout(hidePopup, 5500);
    };

    popup.querySelector('[data-popup-close]')?.addEventListener('click', hidePopup);
    window.setTimeout(showPopup, 8000);
  }

  document.querySelector('[data-submit-product-form]')?.addEventListener('click', () => {
    productForm?.requestSubmit();
  });
});
